<template>
  <v-row
    class="pt-3 pb-3 pl-5 pr-5 notification-card-title"
    no-gutters>
    <template v-if="!loading">
      <v-col
        class="flex flex-wrap"
        cols="11">
        <sTooltip
          class="item text-right"
          :content="($_muted
            ?$t('Notifications.MuteNotifications')
            :$t('Notifications.UnmuteNotifications'))"
          placement="bottom-start"
          type="dark">
          <sButton
            class="pa-0 text-end"
            color="var(--black-color)"
            :icon="($_muted === null ) ? 'loading' :((!$_muted) ? 'notifications' : 'no-notifications')"
            icon-size="16px"
            :loading="$_muted === null"
            small
            type="text"
            @click.prevent.stop="changeState"/>
        </sTooltip>
        <div
          class="notification-card-title-row">
          <TooltipedText
            :line-count="2"
            :route-params="routeProps"
            text-is-url
            :value="cardTitleLabel"/>
          <sTooltip
            class="item text-right"
            :content="$t('Notifications.NotificationsNotViewed')"
            placement="bottom-start"
            type="dark">
            <sChip
              v-if="notViewedNotifications.length"
              class="ml-2"
              data-qa="items-not-viewed-count"
              :text="notViewedNotifications.length"/>
          </sTooltip>
          <sTooltip
            class="item text-right"
            :content="$t('Notifications.NotificationsViewed')"
            placement="bottom-start"
            type="dark">
            <sChip
              v-if="viewedCount"
              :background="'grey'"
              class="ml-2"
              data-qa="items-viewed-count"
              :text="viewedCount"/>
          </sTooltip>
        </div>
      </v-col>
      <v-col
        class="text-right"
        cols="1">
        <sTooltip
          class="item"
          :content="notViewedNotifications && notViewedNotifications.length
            ?$t('Notifications.readMail')
            :$t('Notifications.unreadMail')"
          placement="bottom-end">
          <sButton
            class="pa-0 text-end"
            color="var(--black-color)"
            :disabled="notViewedNotifications && !notViewedNotifications.length"
            :icon="notViewedNotifications && !notViewedNotifications.length ? 'mail-open' : 'mail'"
            icon-size="18px"
            small
            type="text"
            @click.prevent.stop="changeViewed()"/>
        </sTooltip>
      </v-col>
    </template>
  </v-row>
</template>
<script>
import TooltipedText from 'components/common/blocks/tooltiped text/TooltipedText.vue'

import { mapGetters } from 'vuex'
import { innerChatMixin } from 'mixins'
import { debounce } from 'toolkit/utils/util'
import { eventBus } from '@/main'

export default {
  name: 'notificationsGroupCardTitle',
  mixins: [innerChatMixin],
  data() {
    return {
      loading: true,
      routeProps: {},
      cardTitleLabel: null,
      entityNotifications: []
    }
  },
  props: {
    entityItem: {
      type: Object
    },
  },
  computed: {
    ...mapGetters('notification',['isActiveSignalR', 'subscriptions','notifications','accessNotification','notificationEntities']),
    viewedCount() {
      return this.entityItem.notifications.length - this.notViewedNotifications.length
    },
    notViewedNotifications() {
      return this.entityItem.notifications.filter(value => !value.viewed)
    },
  },
  methods: {
    /**
     * mute/unmute
     */
    changeState: debounce(async function () {
      if (!this.entityItem.entity?.entityProps) { return }
      if (!this.isActiveSignalR) {
        eventBus.$emit('ShowSignalAlert', 'Завантаження статусу группи')
        return
      }

      this.$notifier.SendUpdateEventSubscription({
        entity: {
          entityType: this.entityItem.entity.entityProps?.entityType,
          entityId: this.entityItem.entity.entityProps?.entityId
        },
        status: this.$_muted ? this.status.unmute : this.status.mute
      })
    }, 250),
    /**
     * Делаем все не прочитанные сообщения прочитанными
     */
    changeViewed() {
      this.$_changeViewedMessages(this.notViewedNotifications)
    },
    createData() {
      this.loading = true

      const organizationItId = this.entityItem.entity?.entityProps?.OrganizationItId
      this.routeProps = {name: 'tenderitem', params: {org: organizationItId, id: this.entityItem.entity?.entityProps?.entityId}}

      const number = this.entityItem.entity?.entityProps?.Number
      const title = this.entityItem.entity?.entityProps?.Title
      this.cardTitleLabel =  `#${number}.${title}`

      if (!this.notifications?.length) {
        this.entityNotifications = []
      } else {
        this.entityNotifications = this.notifications
          ?.filter(i => i.subscriptionEntityId === this.entityItem.entity.subscriptionEntityId)
          ?.map(i => i.message)
      }
      this.loading = false
    },
  },
  watch: {
    entityItem: {
      immediate: true,
      deep: true,
      handler() {
        this.createData()
      }
    }
  },
  components: {
    TooltipedText
  }
}
</script>
<style scoped lang="scss">
.notification-card-title {
  &-row {
    display: grid;
    gap: 5px;
    grid-template-columns: auto minmax(30px, auto) minmax(30px, auto);
    align-items: center;
    text-align: start;
    padding: 4px;
    font-weight: 500;
    letter-spacing: .01em;
    font-size: 20px;
    line-height: 24px;
  }
  a{
    text-decoration: underline!important;
    font-weight: 500;
  }
}
</style>
